import toLower from 'ramda/src/toLower'
import {
	VIEW_CREATOR_DATA_ROUTE_ID,
	VIEW_TWITCH_CREATOR_DATA_ROUTE_ID,
	VIEW_FACEBOOK_CREATOR_DATA_ROUTE_ID,
	VIEW_TIKTOK_CREATOR_DATA_ROUTE_ID,
	VIEW_YT_CREATOR_DATA_ROUTE_ID,
	POINTS_MARKETPLACE_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth'

import {
	POINTS_MARKETPLACE_LIST_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'

// The creator profile is served by the redesign page (RedesignCreatorProfilePage) in place at these
// URLs. The route descriptors are kept for routing, `recordIdParse` and the `/streamers/...` redirects,
// but declare NO legacy modules: the global <RenderModules /> in _app.tsx renders whatever the matched
// route declares, so any modules here would render the OLD design below the redesign content.
export default {
	[VIEW_CREATOR_DATA_ROUTE_ID]: {
		url: '/creators/:recordId',
		modules: [],
		recordIdParse: toLower,
		makeRequestsOnClient: true,
		redirects: [
			{ source: '/streamers/:recordId' },
		],
	},
	[VIEW_TWITCH_CREATOR_DATA_ROUTE_ID]: {
		url: '/creators/twitch/:recordId',
		modules: [],
		recordIdParse: toLower,
		makeRequestsOnClient: true,
		redirects: [
			{ source: '/streamers/twitch/:recordId' },
		],
	},
	[VIEW_YT_CREATOR_DATA_ROUTE_ID]: {
		url: '/creators/yt/:recordId',
		modules: [],
		makeRequestsOnClient: true,
		redirects: [
			{ source: '/streamers/yt/:recordId' },
		],
	},
	[POINTS_MARKETPLACE_ROUTE_ID]: {
		url: '/points-marketplace',
		authentication: authenticationTypes.authenticated,
		authenticationRole: [
			userGroups.creator,
			userGroups.viewer,
			userGroups.admin,
		],
		modules: [
			POINTS_MARKETPLACE_LIST_MODULE_ID,
		],
	},
	[VIEW_TIKTOK_CREATOR_DATA_ROUTE_ID]: {
		url: '/creators/tiktok/:recordId',
		modules: [],
		makeRequestsOnClient: true,
		redirects: [
			{ source: '/streamers/tiktok/:recordId' },
		],
	},
	[VIEW_FACEBOOK_CREATOR_DATA_ROUTE_ID]: {
		url: '/creators/facebook/:recordId',
		modules: [],
		redirects: [
			{ source: '/streamers/facebook/:recordId' },
		],
	},
}
